import { memo, useCallback } from "react";

import type { ForNodeType } from "@/components/features/_model/types";

import { InputNumberField } from "@/components/ui/form/fields/input-field/input-number";

import { FormFieldLayout } from "../../layouts";

type Props = {
	// 最低価格
	resourceLowestPriceAmount: ForNodeType<number | undefined> | undefined;
	// 最低価格の変更
	onChangeResourceLowestPrice: (amount: number) => void;
};

export const ResourceLowestPriceFormFieldComposition = memo(
	({ resourceLowestPriceAmount, onChangeResourceLowestPrice }: Props) => {
		/**
		 * 最低価格の変更
		 */
		const handleChangeResourceLowestPrice = useCallback(
			(amount?: number) => {
				onChangeResourceLowestPrice(amount!);
			},
			[onChangeResourceLowestPrice],
		);

		return (
			<FormFieldLayout title="提供最低価格">
				<div>
					<div className="flex items-center gap-x-3">
						<InputNumberField
							handleInput={handleChangeResourceLowestPrice}
							value={resourceLowestPriceAmount?.value}
							errorMessage={resourceLowestPriceAmount?.error}
						/>

						<p>円（税込）</p>
					</div>

					<div className="mt-2">
						<p className="whitespace-pre-wrap text-sm text-caption-50">
							{`ディスカウント後の下限価格（/泊）を設定できます。\nディスカウントにより、宿泊金額（※）が下限価格を下回る場合、下限価格が優先されます。\n※「ディスカウントの対象」で選択した商品の合計金額（例：「プラン」「部屋」のみ選択 →「プラン」+「部屋」の合計）`}
						</p>
					</div>
				</div>
			</FormFieldLayout>
		);
	},
);
